import { render } from "./LikeButton.vue?vue&type=template&id=6162e2f4&scoped=true"
import script from "./LikeButton.vue?vue&type=script&lang=js"
export * from "./LikeButton.vue?vue&type=script&lang=js"

import "./LikeButton.vue?vue&type=style&index=0&id=6162e2f4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6162e2f4"]])

export default __exports__